export default "__VITE_ASSET__BCEtoldJ__"